import React from 'react';
import PropTypes from 'prop-types';

import { ButtonRound, Spacer } from '@ontruck/orc';
import { StyledFloatingButton } from './styled';

const ReorderStopButtons = ({ allowMoveUp, allowMoveDown, onUpClick, onDownClick, ...props }) => {
  return (
    <StyledFloatingButton {...props}>
      {allowMoveUp && (
        <Spacer mBottom="XS">
          <ButtonRound skin="primary" size="S" onClick={onUpClick} icon="up" shadow />
        </Spacer>
      )}
      {allowMoveDown && (
        <Spacer>
          <ButtonRound skin="primary" size="S" onClick={onDownClick} icon="down" shadow />
        </Spacer>
      )}
    </StyledFloatingButton>
  );
};

ReorderStopButtons.propTypes = {
  onUpClick: PropTypes.func,
  onDownClick: PropTypes.func,
  allowMoveUp: PropTypes.bool,
  allowMoveDown: PropTypes.bool,
};

ReorderStopButtons.defaultProps = {
  onUpClick: () => {
    /*noop*/
  },
  onDownClick: () => {
    /*noop*/
  },
};

export default ReorderStopButtons;
